import PropTypes from 'prop-types';

import ErrorBoundary from 'components/ErrorBoundary';
import GenericError from 'components/GenericError';

import placeholder from 'lib/placeholder';

import List from './CommentsList';

const CommentsList = ({
  aliasId = null,
  className,
  gaEventCategory,
  isOfferCommentsAllowed,
  isShowingPriceComparator,
  offerCommentsCount,
  offerId,
  offerStatusName,
  serverComments,
}) => (
  <ErrorBoundary
    fallback={
      <GenericError message={placeholder('errors.couldNotLoadComments')} />
    }
  >
    <List
      aliasId={aliasId}
      className={className}
      gaEventCategory={gaEventCategory}
      initialComments={serverComments}
      isCommentsAllowed={isOfferCommentsAllowed}
      isReadOnly={!isOfferCommentsAllowed}
      isShowingPriceComparator={isShowingPriceComparator}
      offerCommentsCount={offerCommentsCount}
      offerId={offerId}
      offerStatusName={offerStatusName}
    />
  </ErrorBoundary>
);

CommentsList.displayName = 'DynamicallyLoadedOfferCommentsWithRef';

CommentsList.propTypes = {
  aliasId: PropTypes.number,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  isOfferCommentsAllowed: PropTypes.bool.isRequired,
  offerCommentsCount: PropTypes.number.isRequired,
  offerId: PropTypes.number.isRequired,
  offerStatusName: PropTypes.string.isRequired,
  serverComments: PropTypes.arrayOf(
    PropTypes.shape({
      commentId: PropTypes.number.isRequired,
      parentId: PropTypes.number,
      userId: PropTypes.number.isRequired,
      commentText: PropTypes.string.isRequired,
      commentRaw: PropTypes.string.isRequired,
      commentDate: PropTypes.string.isRequired,
      commentLikes: PropTypes.number.isRequired,
      commentStatusName: PropTypes.string.isRequired,
      commentFixed: PropTypes.bool.isRequired,
      relevance: PropTypes.number.isRequired,
      commentStars: PropTypes.number,
      reviewAliasId: PropTypes.number,
      edited: PropTypes.bool.isRequired,
      isReview: PropTypes.bool.isRequired,
      userLevel: PropTypes.number.isRequired,
      userName: PropTypes.string.isRequired,
      userPhoto: PropTypes.string.isRequired,
      userSpecialtyName: PropTypes.string,
      userTypeName: PropTypes.string.isRequired,
      userUsername: PropTypes.string.isRequired,
      offerPhoto: PropTypes.string,
      replies: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    })
  ).isRequired,
};

export default CommentsList;
